var Loyer_Calculator = {
    _is_listening: true,
    _has_intro:false,

    init: function () {

        if($(".gli-intro").length){
            Loyer_Calculator._has_intro = true;
        }
        if(Loyer_Calculator._has_intro) {
            $(".gli-intro .btn").on("click touchend", function (e) {
                if (e.type == "touchend") {
                    $(this).off("click");
                }
                var _y_dest = $(".block-calculateur-de-loyer").offset().top;

                $("html, body").animate({scrollTop: _y_dest}, 500);
            });
			$(".gli-intro input").on('keyup', function (e) {
				if (e.key === 'Enter' || e.keyCode === 13) {
					var _y_dest = $(".block-calculateur-de-loyer").offset().top;
					$("html, body").animate({scrollTop: _y_dest}, 500);
				}
			});


            $(".gli-intro input").change(function () {
                if (Loyer_Calculator._is_listening) {
                    Loyer_Calculator.update_value_from_intro();
                }
            });
            $(".gli-intro input").on("input", function () {
                if (Loyer_Calculator._is_listening) {
                    Loyer_Calculator.update_value_from_intro();
                }
            });

        }

        $(".block-calculateur-de-loyer .custom-rangeSlider").find("input").change(function(){
            $(".block-calculateur-de-loyer #loyer").parent().addClass("focused");
            $(".block-calculateur-de-loyer #loyer").val(parseFloat($(".txt-custom-range").val()));

            Loyer_Calculator._is_listening = false;

            Loyer_Calculator.calculate_pourcent();

            setTimeout(function(){
                Loyer_Calculator._is_listening = true;
            }, 200);
        })

        $(".block-calculateur-de-loyer #loyer").on("input change",  function () {


            $(".block-calculateur-de-loyer .custom-rangeSlider input").val($(".block-calculateur-de-loyer #loyer").val());

            Loyer_Calculator._is_listening = false;

            Loyer_Calculator.calculate_pourcent();

            setTimeout(function(){
                Loyer_Calculator._is_listening = true;
            }, 200);

        });


        Loyer_Calculator.calculate_pourcent();

    },
    update_value_from_intro: function () {
        setTimeout(function () {
            $(".block-calculateur-de-loyer input").parent().addClass("focused");
            $(".block-calculateur-de-loyer input").val($(".gli-intro input").val());

            Loyer_Calculator.calculate_pourcent();
        }, 40);
    },
    calculate_pourcent:function(){

        var _val = parseFloat($('.block-calculateur-de-loyer input[name="loyer"]').val().split(",").join("."));
        var _length = $('.block-calculateur-de-loyer input[name="loyer"]').val().length;
        if(_length <= 0){
            _length = 1;
        }
        $('.block-calculateur-de-loyer input[name="loyer"]').css({
            "max-width":_length * 22
        })

        if(Loyer_Calculator._is_listening == false && Loyer_Calculator._has_intro){
            $(".gli-intro input").parent().addClass("focused");
            $(".gli-intro input").val($(".gli-loyer #loyer").val());
        }


        $(".calc-container").each(function(){
            var _pourcent = parseFloat($(this).attr("data-pourcentage")) / 100;

            var _cost = Math.round((_val * _pourcent)*100)/100;

            console.log("COST : " + _cost);
            _cost = Math.round(_cost * 100)/100;

            if(_cost % 1 != 0){
                if((_cost * 10) % 1 == 0){
                    _cost += "0";
                }
            }

            _cost = "" + _cost;
            if(isNaN(_cost)){
                _cost = "Saissez un montant de loyer";
                $(this).find(".result .value").addClass('error');
                $(this).find(".result .legend").hide();
            }else{
                $(this).find(".result .value").removeClass('error');
                $(this).find(".result .legend").show();
            }
            $(this).find(".result .value").html(_cost.split(".").join(","));

        })

    }
}

$(window).load(function () {
    if ($(".block-calculateur-de-loyer").length) {
        Loyer_Calculator.init();
    }
})